import Vue from 'vue'
import router from './router.js'
import Vuex from 'vuex'
import axios from 'axios'
import VueCookie from 'vue-cookie'
import okaTool from './okaTool.js'
import siteConfig from './siteConfig.js'
import siteTool from './siteTool.js'
import talkTool from './talkTool.js'
import socketIO from 'socket.io-client'
import _ from 'lodash';
// import { JSEncrypt } from 'jsencrypt' 23
import { version } from '../package.json';
import { Validator } from 'vee-validate'
import validatorZh_TW from './validate-zh_TW'
import validatorEn from './validate-en'

Vue.use(Vuex);

let _os = okaTool.checkOS(),
    _mobileMode = okaTool.checkMobile(),
    $_getDatePickerDefaultData = () => {

        return {
            show: false,
            id: '',
            select: {
                year: 1970,
                month: 1,
                date: 1,
                hour: 8,
                minutes: 0,
            },
            format: 'AD',
            type: 'date',
            target: null,
            removeAble: false,
            disabledMinutes: false,
            action: () => {},
            dayValidate: () => {},
        }
    }

let store = new Vuex.Store({
        state: {
            timestamp: okaTool.getUUID(),
            version: version,
            preSendVersion: '',
            user: siteTool.getDefaultUser(), //使用者資訊
            talk: talkTool.getDefaultTalk(),
            datePicker: $_getDatePickerDefaultData(),//日期參數
            talkUnInit: true,
            accounts: [],
            unDiscountCuno: [],
            token: '',
            userNotification: [],
            path: '', //用來對照 active 的路徑,
            loadingState: 0, // >0 就會啟用 loading 狀態
            isRouterAlive: true,
            os: _os,
            mobileMode: _mobileMode, //是否為手機模式
            popUps: [],
            notifications: [],
            toolTips: [],
            confirmFuncQueue: [], //token 失效時，預備執行的隊列
            globalClickFuncQueue: [], //點擊全域執行的隊列
            globalResizeFuncQueue: [], //resize 全域執行的隊列
            globalScrollFuncQueue: [],
            webSocketServise: {}, //通知用 socket
            webSocketTalk: {}, //聊聊用 socket
            langID: 'zh',
            langLibrary: {}, //多語系資料
            isPlayAudio: false,//播放背景音樂
            productClass: [],
            productList: [],
            productListInit: null, //初始化的日期
            dispatchList: [],
            shoppingCart: [],
            shoppingCartInit: false, 
            packageData: [],
            packageMultipleData: [],
            qualityList: [],
            selectedDateList: [],//可選擇的日期區間
            selectedDateListInit: null, //初始化的可選擇的日期區間
            talkChannels: [], //聊聊頻道列表
            talkUIList: [], //聊聊UI列表
            talkEmployees: [], //聊聊員工列表
            talkMessage: [], //聊聊訊息列表
            stickerList: [], //貼圖列表
            stickerUnInit: true, //貼圖 flag
            talkViewTime: {}, //聊聊閱讀時間
            priceObject: {},
            creditBalance: null, //授信金額
            creditTime: null, //授信時間
            showNav: true,
            showTalkList: false,
        },
        getters: {
            userPhoto: function(state, getters){
                let $user = state.user,
                    _accountid = $user.accountid,
                    _timestamp = state.timestamp;

                let _url = siteConfig.ApiUrl,
                    _path = 'FileUpload';

                _url = _url.replace('/salenet_api', '');

                if( siteConfig.devEvent ) {
                    _path = 'FileUpload_Test';
                }
    
                return _url +'/APIGateway/api/dl?path='+ _path +'/AccountPhoto/'+ _accountid +'.jpg&timestamp='+ _timestamp;
            },
            useChannel: function(state, getters){
                let $talk = state.talk,
                    _cid = $talk.cid;

                if( _cid ) {
                    let $talkChannels = state.talkChannels,
                        $result = $talkChannels.find(channel => channel.cid === _cid);

                    return $result;
                }else {
                    return null;
                }
            },
            division: function(state, getters){
                //判斷客戶所屬的事業部
                let $user = state.user,
                    $co = $user.co.toUpperCase(),
                    $div = $user.div.toUpperCase()

                if($co == 'AH'){ //台塑旭
                    return 'AH'
                }else if($co == 'AL'){ //台塑大金
                    return 'AL'
                }else if ($co == '1'){ //台塑公司
                    switch($div){
                        case '1': 
                            return 'PVC' //塑膠
                        case '2':
                            return 'TRL' //台麗朗
                        case '4':
                            return 'DS' //電石
                        case '8':
                            return 'PE' //聚烯
                        case 'A':
                            return 'HP' //化品
                        case 'P':
                            return 'PP' //聚丙烯
                    }
                }else {
                    return null
                }
            }
        },
        mutations: {
            navToggle: function(state, boolean){
                let _result = boolean;

                if( typeof boolean !== 'boolean' ) {
                    _result = !state.showNav;
                }

                this.commit('changeState', {
                    showNav: _result,
                });
            },
            setComment: function(state, date){
                let _date = date || 7;

                VueCookie.set('comment', new Date(Date.now() + _date * 24 * 60 * 60 * 1000).toISOString(), 365); //寫 7 天後可以
            },
            updateVersion: function(state, ver) { //與現有資料做比對
                let _version = state.version;

                console.log(_version)

                // if( !siteConfig.devEvent && _version !== ver ) {
                //     let _serverIsNew = siteTool.versionComparer(_version, ver);

                //     if( _serverIsNew ) { //避免測試機刷新崩潰
                //         let $version = _version.split('.'),
                //             $serverVersion = ver.split('.');

                //         if( ($version[0] !== $serverVersion[0] || $version[1] !== $serverVersion[1]) && !siteConfig.devEvent ) {
                //             let $popUps = state.popUps,
                //                 $target = $popUps.find(item => item.sn === 'update');

                //             console.log(state.langLibrary[state.langID]['site.update.notification.html']);

                //             // if( !$target ) {

                //             //     this.commit('pushPopUp', {
                //             //         type: 'alert',
                //             //         sn: 'update',
                //             //         content: {
                //             //             caption: state.langLibrary[state.langID]['site.update.notification.caption'],
                //             //             html: state.langLibrary[state.langID]['site.update.notification.html'],
                //             //             actionName: state.langLibrary[state.langID]['site.update.notification.action'],
                //             //             actionIcon: 'rotate_left',
                //             //             actionTheme: 'major',
                //             //             action: () => {
                //             //                 window.location.reload();
                //             //             }
                //             //         }
                //             //     });
                //             // }
                //         }
                        
                //     }else {

                //         if( state.user.sn && _version !== state.preSendVersion ) { //有登入才能打，版本號沒打過才能打
                //             let _url = siteTool.apiUrl({
                //                     class: 'Version',
                //                 });

                //             axios.post(_url, {version: _version});

                //             this.commit('changeState', {
                //                 preSendVersion: _version,
                //             });
                //         }
                //     }
                // }
            },
            talkActive: function(state, channel) { //啟動某一則聊天
                let _activeCid = state.talk.cid,
                    _nextSend = state.talk.nextSend,
                    _thisCid = channel.cid;

                this.commit('talkBubbleClose', channel);

                if( _activeCid !== _thisCid ) {
                    
                    this.commit('talkBubbleShow', { //先把正在聊天的泡泡收起來
                        cid: _activeCid, 
                    });

                    this.commit('talkInterfaceClose');
                    this.commit('talkInterfaceShow', channel);
                }

                if( _nextSend ) {

                    this.commit('talkSend', {
                        channel: _thisCid,
                        message: _nextSend,
                    });

                    this.commit('talkSet', {
                        nextSend: '',
                    });
                }
            },
            talkCreate: function(state, aid) { //開啟某一則聊天

                this.commit('talkCommand', {
                    command: 'createPersonalChannel',
                    employee: aid,
                });
            },
            talkInterfaceShow: function(state, channel) { //開啟聊天
                let $user = state.user,
                    _adscuno = $user.adscuno;

                let _cid = channel.cid;

                this.commit('talkSet', {
                    cid: _cid,
                });

                this.commit('talkCommand', {
                    command: 'getMessage',
                    cid: _cid,
                    timestamp: 0,
                    direction: 'latest',
                    updateTimeFlag: true,
                });

                VueCookie.set(_adscuno +'_cid', _cid, 3);
            },
            talkInterfaceClose: function(state){ //關閉聊天
                let $user = state.user,
                    _adscuno = $user.adscuno;

                this.commit('changeState', {
                    talkMessage: [],
                });

                this.commit('talkSet', {
                    cid: null,
                });

                VueCookie.delete(_adscuno +'_cid');
            },
            talkBubbleShow: function(state, channel){ //開啟泡泡
                let $user = state.user,
                    _adscuno = $user.adscuno;

                let $talkUIList = state.talkUIList,
                    _cid = channel.cid;

                if( _cid && !$talkUIList.includes(_cid) ) {

                    $talkUIList.push(_cid);
        
                    VueCookie.set(_adscuno +'_talkUIList', JSON.stringify($talkUIList), 3);
                }
            },
            talkBubbleClose: function(state, channel) { //關閉泡泡
                let $user = state.user,
                    _adscuno = $user.adscuno;

                let $talkUIList = state.talkUIList,
                    _cid = channel.cid;
                    
                let _index = $talkUIList.indexOf(_cid);

                if( _index > -1 ) {
                    $talkUIList.splice(_index, 1);

                    VueCookie.set(_adscuno +'_talkUIList', JSON.stringify($talkUIList), 3);
                }
            },
            talkSend: function(state, opt){
                let _channel = opt.channel,
                    _message = opt.message,
                    _type = opt.type || 1;

                let $node = {
                        command: 'sendMessage',
                        cid: _channel,
                        type: _type,
                        uuid: okaTool.getUUID()
                    }

                if( _type === 1 ) {
                    $node.message = _message;
                }else if( _type === 6 ) {
                    $node.message = '';
                    $node.extra2 = _message;
                }

                this.commit('talkCommand', $node);
            },
            talkCommand: function(state, opt){
                let $socket = state.webSocketTalk;

                if( $socket.connected ) {
                    let _jsonString = JSON.stringify(opt);
                        // _message = talkTool.AESEncryptMessage(_jsonString);

                    // $socket.emit('command', _message)

                    $socket.emit('command', _jsonString)
                }
            },
            initDatePicker: function(state){ //init datePicker
                state['datePicker'] = $_getDatePickerDefaultData();
            },
            setDatePicker: function(state, opt) { //改變 datePicker
                
                if( opt && typeof opt === 'object' ) {
                    
                    for( let _key in opt ) {
                        state['datePicker'][_key] = opt[_key];
                    }
                }
            },
            setFavorite: function(state, opt){
                let _sn = opt.sn,
                    _favorite = !!opt.favorite,
                    $_callback = opt.callback;

                let $productList = state.productList,
                    $target = $productList.find(product => {
                        return product.product_sn === _sn;
                    });

                let $_done = () => {
                        $target.is_favorite = _favorite;

                        if( $_callback && typeof $_callback === 'function' ) {   
                            $_callback();
                        }
                    }

                if( $target ) {

                    if( state.user.sn ) {
                        let _url = '',
                            $condition = null

                        if( _favorite ) { //add
                            _url = siteTool.apiUrl({
                                class: 'FavoriteList',
                                func: 'Add',
                            });

                            $condition = [_sn]
                        }else { //remove
                            _url = siteTool.apiUrl({
                                class: 'FavoriteList',
                                func: 'Delete',
                            });

                            $condition = {
                                product_sn: _sn
                            }
                        }

                        axios.post(_url, $condition).then(res => { //弄完所有設定後開始取資料
                            $_done();
                        }).catch(error => {

                            this.commit('catchError', {
                                error: error,
                                callback: () => {
                                    this.commit('setFavorite', opt);
                                }
                            });
                        });
                    }else {
                        $_done();
                    }
                }
            },
            changeShoppingCart: function(state, opt) { //控制購物車
                let $func = opt.func || 'add', //add、remove
                    _notification = opt.notification,
                    $data = opt.data;

                if( typeof _notification !== 'boolean' ) {
                    _notification = true;
                }

                let $shoppingCart = state.shoppingCart;

                if( $func === 'add' ) {
                    siteTool.initShoppingCart($data);

                    $shoppingCart.push($data);

                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                    dataLayer.push({
                        event: "add_to_cart",
                        ecommerce: {
                            currency: "TWD",
                            value: $data.price * $data.qty,
                            items: [
                                {
                                    item_id: $data.cart_sn,
                                    item_name: $data.product_s,
                                    item_brand: "Formosa Plastic Corporation",
                                    item_category: $data.product_b,
                                    item_category2: $data.product_m,
                                    item_category3: $data.product_s,
                                    price: $data.price,
                                    quantity: $data.qty
                                }
                            ]
                        }
                    });

                }else if( $func === 'remove' ) {
                    let _index = $shoppingCart.indexOf($data);

                    if( _index >= 0 ) {
                        $shoppingCart.splice(_index, 1);

                        if( _notification ) {

                            this.commit('pushNotification', {
                                type: 'notification',
                                content: {
                                    html: state.langLibrary[state.langID]['site.status.removesuccess']
                                }
                            });
                        }
                    }
                }
            },
            changeState: function(state, opt) { //改變 state

                if( typeof opt === 'object' ) {

                    for( let _key in opt ) {
                        state[_key] = opt[_key]
                    }
                }
            },
            updatePopUpSn: function(state, opt) { //改變 popup sn
                let $popup = state.popUps,
                    $target = $popup[0];

                let $opt = opt || {}

                let _sn = $opt.sn || '',
                    _newSn = $opt.newSn || okaTool.getUUID();

                if( _sn ) {

                    let $findTarget = $popup.find(item => {
                            item.sn = _sn;
                        });

                    if( $findTarget ) {
                        $target = $findTarget;
                    }
                }
                
                $target.sn = _newSn;
            },
            userSet: function(state, opt) { //覆蓋登入資訊

                for( let _key in opt ) {
                    state.user[_key] = opt[_key];
                }

                this.commit('webSocketServiseDisconnect');

                if( opt.sn ) {
                    this.commit('webSocketServiseInit');
                }
            },
            talkSet: function(state, opt) {

                for( let _key in opt ) {
                    state.talk[_key] = opt[_key];
                }
            },
            isLoadingChange: function(state, opt) {
                let _loadingState = state.loadingState;

                if( opt === true ) {
                    state.loadingState = _loadingState + 1;
                }else if( opt === false ) {
                    state.loadingState = Math.max(_loadingState - 1, 0);
                }else if( opt === 'reset' ){
                    state.loadingState = 0;
                }
            },
            reload: function(state) { //改變 state
                state.isRouterAlive = false;

                let $timer = null,
                    _dis = 6,
                    $timedCount = () => {

                        $timer = window.setInterval(() => {
                            state.isRouterAlive = true;
                            window.clearTimeout($timer);
                        }, _dis);
                    };

                $timedCount();
            },
            soundChange: function(state) { //改變背景音
                state.isPlayAudio = state.isPlayAudio? false : true;
            },
            pushMessage: function(state, opt){ //============= 資訊推送 tool tip & pop up 共用的原始方法 =============
                const _type = opt.type,
                    $object = opt.object;

                $object.sn = opt.object.sn || okaTool.getUUID();

                let $content = null;

                if( _type === 'popup' ) {
                    $content = state.popUps;
                }else if( _type === 'tooltip' ) {

                    if (!state.mobileMode) { //手機無法使用 tooltip
                        this.commit('clearToolTip'); //推送 tooltip 之前先刪除目前的 tooltip
                        $content = state.toolTips;
                    }
                }else if( _type === 'notification' ) {
                    $content = state.notifications;
                }else {
                    console.log('message 類別錯誤。')
                }

                if( $content ) {
                    $content.push($object);
                }
            },
            clearMessage: function(state, opt){
                const _type = opt.type,
                    _area = opt.area; //可能是 number、sn、Array、object 或 'all'

                let $content = null;

                if( _type === 'popup' ) {
                    $content = state.popUps;
                }else if( _type === 'tooltip' ) {
                    $content = state.toolTips;
                }else if( _type === 'notification' ) {
                    $content = state.notifications;
                }else {
                    console.log('message 類別錯誤。');
                    return false;
                }

                if( _area === 'all' ) {
                    $content.splice(0, $content.length);
                }else if( typeof _area === 'string' || typeof _area === 'number' ) { //字串或數字應該是 sn
                    let $item = $content.find(item => { return item.sn === _area });

                    if( $item ) {
                        let _index = $content.indexOf($item);

                        $content.splice(_index, 1);
                    }else {
                        console.log('找不到此物件', _area);
                    }
                }else if( Array.isArray(_area) ) { //一個陣列，就一個一個去帶

                    _area.forEach(item => {

                        this.commit('clearMessage', {
                            type: _type,
                            area: item
                        });
                    });
                }else if( typeof _area === 'object' ) { //整個物件，找到物件並刪除
                    let _index = $content.indexOf(_area)

                    if( _index >= 0 ) {
                        $content.splice(_index, 1);
                    }else {
                        console.log('找不到此物件', _area);
                    }
                }else {
                    $content.splice($content.length - 1, 1); //移除最上面的一個
                }
            },
            pushPopUp: function(state, object){ //增加 popup

                this.commit('pushMessage', {
                    type: 'popup',
                    object: object
                });
            },
            clearPopUp: function(state, area){ //移除 popup 一個或全部(all)

                this.commit('clearMessage', {
                    type: 'popup',
                    area: area
                });
            },
            alert: function(state, opt){ //增加 popup 的一種簡單模式
                let $object = { type: 'alert' }

                if( typeof opt === 'string' ) {
                    $object.content = { html: opt }
                }else if( typeof opt === 'object' ) {
                    $object.content = opt;
                }else {
                    console.log('alert 類別錯誤。')
                }

                this.commit('pushMessage', {
                    type: 'popup',
                    object: $object
                });
            },
            pushToolTip: function(state, object){ //增加 tooltip

                this.commit('pushMessage', {
                    type: 'tooltip',
                    object: object
                });
            },
            clearToolTip: function(state){ //移除全部的 tooltip 一個或全部(all)，目前邏輯永遠只有一個 toolTip

                this.commit('clearMessage', {
                    type: 'tooltip',
                    area: 'all'
                });
            },
            pushNotification: function(state, object){ //增加 notification

                this.commit('pushMessage', {
                    type: 'notification',
                    object: object
                });
            },
            clearNotification: function(state, area){ //移除全部的 notification 一個或全部(all)

                this.commit('clearMessage', {
                    type: 'notification',
                    area: area
                });
            },
            confirmFuncQueuePush: function(state, func){
                state.confirmFuncQueue.push(func)
            },
            confirmFuncQueueRun: function(state){
                let $funcs = state.confirmFuncQueue;

                $funcs.forEach(func => {
                    func();
                });

                this.commit('confirmFuncQueueClear');
            },
            confirmFuncQueueClear: function(state){
                let $funcs = state.confirmFuncQueue,
                    _length = $funcs.length;

                if( _length ) {
                    $funcs.splice(0, _length);
                }
            },
            globalClickFuncQueuePush: function(state, obj){
                state.globalClickFuncQueue.push(obj);
            },
            globalClickFuncQueueRun: function(state, filterID){

                if( filterID ) { //如果他有傳 id 進來

                    state.globalClickFuncQueue.forEach(item => {

                        if( item.id !== filterID ) {
                            item.func();
                        }
                    });

                }else {

                    state.globalClickFuncQueue.forEach(item => {
                        item.func();
                    });
                }
            },
            globalClickFuncQueueClear: function(state, id){
                let $queue = state.globalClickFuncQueue,
                    $target = $queue.find(item => {
                        return item.id === id;
                    });

                if( $target ) {
                    let _index = $queue.indexOf($target);

                    $queue.splice(_index, 1);
                }
            },
            globalResizeFuncQueuePush: function(state, obj){
                state.globalResizeFuncQueue.push(obj);
            },
            globalResizeFuncQueueRun: function(state){
                state.globalResizeFuncQueue.forEach(item => {
                    item.func();
                });
            },
            globalResizeFuncQueueClear: function(state, id){
                let $queue = state.globalResizeFuncQueue,
                    $target = $queue.find(item => {
                        return item.id === id;
                    });

                if( $target ) {
                    let _index = $queue.indexOf($target);

                    $queue.splice(_index, 1);
                }
            },
            globalScrollFuncQueuePush: function(state, obj){
                state.globalScrollFuncQueue.push(obj);
            },
            globalScrollFuncQueueRun: function(state){
                state.globalScrollFuncQueue.forEach(item => {
                    item.func();
                });
            },
            globalScrollFuncQueueClear: function(state, id){
                let $queue = state.globalScrollFuncQueue,
                    $target = $queue.find(item => {
                        return item.id === id;
                    });

                if( $target ) {
                    let _index = $queue.indexOf($target);

                    $queue.splice(_index, 1);
                }
            },
            loginProcess: function(state, user){ //執行登入後的一系列流程
                this.commit('userSet', user);
                
                VueCookie.set('user', JSON.stringify(user), 3);

                this.commit('updateFavorite');

                //如果登入後沒有產品類別 & 日期資料，就再撈一次

                if( !state.productClass.length ) {
                    this.commit('initProductClassData');
                }

                if( !state.unDiscountCuno.length ) {
                    this.commit('initUnDiscountCuno');
                }
                
                if( !state.selectedDateList.length ) {
                    this.commit('initHolidayList');
                }

                this.commit('confirmFuncQueueRun');
                this.commit('initTalkData');

                this.commit('reload');

                this.commit('pushNotification', {
                    type: 'notification',
                    content: {
                        html: state.langLibrary[state.langID]['site.status.loginsuccess']
                    }
                });
                
                let date = new Date()

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'loginSuccess',
                    'userId': user.accountid, //帳號
                    'userName': user.cuabr, //簡稱
                    'customer': user.cuno,
                    'currentTime': date.toISOString(), //現在時間
                });
            },
            clearStatus: function(state){ //移除所有提示
                this.commit('isLoadingChange', false);
                this.commit('confirmFuncQueueClear');

                this.commit('clearMessage', {
                    type: 'popup',
                    area: 'all'
                });

                this.commit('clearMessage', {
                    type: 'tooltip',
                    area: 'all'
                });
            },
            clearTalk: function(){

                this.commit('changeState', {
                    talk: talkTool.getDefaultTalk(),
                    talkUnInit: true,
                    talkChannels: [],
                    talkUIList: [],
                    talkEmployees: [],
                    talkMessage: [],
                    stickerList: [],
                    stickerUnInit: true,
                    talkViewTime: {},
                });
            },
            clearUserData: function(state){ //刪除產品與包裝資訊、價格資訊、購物車

                this.commit('changeState', {
                    productList: [],
                    productListInit: null,
                    dispatchList: [],
                    packageData: [],
                    packageMultipleData: [],
                    qualityList: [],
                    shoppingCart: [],
                    shoppingCartInit: false,
                    priceObject: {},
                    creditBalance: null,
                    creditTime: null,
                });
            },
            clearAuth: function(state){ //刪除登入資訊、刪掉 cookie、移除所有狀態
                this.commit('userSet', siteTool.getDefaultUser());
                this.commit('changeState', {
                    token: '',
                    userNotification: [],
                });

                this.commit('clearStatus');
                this.commit('clearTalk');

                VueCookie.delete('user');
                VueCookie.delete('token');
            },
            logout: function(state, callback) { //覆蓋登入資訊
                this.commit('clearAuth');
                this.commit('initUserData');

                if( callback && typeof callback === 'function' ) {
                    callback();
                }

                this.commit('pushNotification', {
                    type: 'notification',
                    content: {
                        html: state.langLibrary[state.langID]['site.status.logoutsuccess']
                    }
                });
            },
            confirmToken: function(state, res){ //驗證 token 或顯示連線錯誤
                let $popups = state.popUps,
                    $login = $popups.find(item => { return item.type === 'relogin' });

                if( !$login ){ //如果已經有要求了就不要再跳了

                    this.commit('pushPopUp', {
                        type: 'relogin',
                    });
                }

                if( res.callback && typeof res.callback === 'function' ) {
                    this.commit('confirmFuncQueuePush', res.callback);
                }
            },
            catchError: function(state, res){ //處理 error 問題
                let $error = res.error,
                    _code = $error.code;

                //https://www.notion.so/1bb797ef31f5411f8ed47ecb1ae573ea?v=7f2c85ed74c548c1b183ed3bea9b2b07
                
                if( _code === '1024' ) { //帳密錯誤

                    this.commit('pushPopUp', {
                        type: 'routerPush',
                        content: {
                            html: $error.message,
                            path: '/',
                            cancel: false
                        }
                    });
                }else if( _code === '9000' || _code === '9001' || _code === '9002' ) { //token 錯誤

                    if( res.callback && typeof res.callback === 'function' ) {
                        this.commit('confirmFuncQueuePush', res.callback);
                    }

                    this.commit('confirmToken', res);
                }else if( _code === '2001' || _code === '2002' || _code === '2011' || _code === '2012' || _code === '2021' || _code === '2023'  ) { //交易流程錯誤
    
                    this.commit('pushPopUp', {
                        type: 'alert',
                        content: {
                            caption: _code,
                            html: $error.message,
                            actionName: state.langLibrary[state.langID]['site.func.reload'],
                            action: () => { //產品價格跟價差有可能不一樣
                                this.commit('initUserData');
                            }
                        }
                    });
                    
                }else{
                    this.commit('sendError', $error);
                }
            },
            sendError: function(state, res){ //紀錄錯誤 log 並跳出 popup 告知
                let _code = res.code,
                    _message = res.message;

                if( _code && _message ) {

                    this.commit('pushPopUp', {
                        type: 'alert',
                        content: {
                            caption: _code,
                            html: _message,
                        }
                    });
                }else {
                    console.error(res);
                }
            },
            webSocketServiseInit: async function(state){ //init WebSocket
                let _str = '/activity',
                    $socket = await socketIO.connect(siteConfig.webSocketServiseUrl + _str);

                let $user = state.user;

                $socket.emit('join', {
                    id: $user.adscuno,
                    name: $user.cufn,
                    codiv: '',
                    jobtitle: '',
                    lastoperatingtime: '',
                    block: ''
                });

                if( siteConfig.devEvent ) {

                    $socket.on('connect', () => {
                        console.log('webSocketServise 連線');
                    });

                    $socket.on('disconnect', () => {
                        console.log('webSocketServise 斷線');
                    });
                }

                this.commit('userNotificationInit', $socket);

                this.commit('changeState', {
                    webSocketServise: $socket
                });
            },
            webSocketTalkInit: async function(state){ //init WebSocket
                let $user = state.user,
                    _adscuno = $user.adscuno;

                let $socket = await socketIO.connect(siteConfig.talkDomainUrl, {
                        path: '/socket.io/socket4',
                    }),
                    $talk = state.talk;

                $socket.on('connect', () => {
                    console.log('webSocketTalk 連線');

                    this.commit('talkCommand', {
                        command: 'getInitialData',
                    });
                    
                    // let _accessTokenAESKey = $talk.accessToken +'_'+ talkTool.AESHexKey,
                    //     $crypt = new JSEncrypt();

                    // $crypt.setPublicKey(talkTool.RSAPublicKey);
                    // _accessTokenAESKey = $crypt.encrypt(_accessTokenAESKey);
                    
                    // $socket.emit('tokenVerify', {
                    //     command: 'tokenVerify',
                    //     appVersion: '9.9.9',
                    //     platformNumber: 3,
                    //     accessTokenAESKey: _accessTokenAESKey,
                    //     encryptVersion: talkTool.encryptVersion
                    // });
                    
                    $socket.emit('tokenVerify', {
                        command: 'tokenVerify',
                        appVersion: '9.9.9',
                        platformNumber: 3,
                        accessToken: $talk.accessToken,
                    });
                });

                $socket.on('message', (message) => {
                    let $data = message.data;

                    if( message.encryptVersion && message.dataString ) {
                        // let _dataString = talkTool.AESDecryptMessage(message.dataString);
                        
                        try {
                            // $data = JSON.parse(_dataString)
                            
                            $data = JSON.parse(message.dataString);
                        } catch (e) {
                            console.error(message + ': parse json error !');
                        }
                    }
        
                    switch(message.command){

                        case 'tokenVerifyResponse':
                            break

                        case 'getInitialData':

                            this.commit('talkCommand', {
                                command: 'getInitialData',
                            });

                            break

                        case 'getInitialDataResponse':

                            if( state.talkUnInit ) { //如果還沒 init 過 user
                                let $talkData = $data.mydata;

                                delete $talkData.avatar
                                
                                this.commit('talkSet', $talkData);

                                let _cid = VueCookie.get(_adscuno +'_cid'),
                                    _talkUIList = VueCookie.get(_adscuno +'_talkUIList');
                
                                if( _cid ) {
                
                                    this.commit('talkActive', {
                                        cid: parseInt(_cid, 10),
                                    });
                                }
            
                                if( _talkUIList ) {
            
                                    this.commit('changeState', {
                                        talkUIList: JSON.parse(_talkUIList)
                                    });
                                }

                                this.commit('talkCommand', {
                                    command: 'getStickerList',
                                });

                                this.commit('changeState', {
                                    talkUnInit: false,
                                });
                            }

                            this.commit('changeState', {
                                talkChannels: $data.channels,
                            });
                            
                            break

                        case 'getMessage':

                            this.commit('talkCommand', {
                                command: 'getMessage',
                                cid: $data.cid,
                                timestamp: $data.timestamp,
                                direction: 'down',
                                updateTimeFlag: $talk.cid && $talk.cid === $data.cid,
                            });

                            break
                            
                        case 'createPersonalChannelResponse':
                            
                            this.commit('talkActive', {
                                cid: $data.cid,
                            });

                            this.commit('talkCommand', {
                                command: 'getMessage',
                                cid: $talk.cid,
                                timestamp: 0,
                                direction: 'latest',
                                updateTimeFlag: true,
                            });

                            this.commit('talkCommand', {
                                command: 'getInitialData',
                            });

                            break

                        case 'getMessageResponse':

                            this.commit('talkCommand', {
                                command: 'getViewTime',
                                cid: $talk.cid 
                            });

                            this.commit('talkCommand', {
                                command: 'getInitialData',
                            });

                            if( $talk.cid === $data.cid ){ //訊息為當前對象發送時，才進行天室訊息的變動
                                let _direction = $data.direction,
                                    $messages = $data.messages;

                                let $firstTalk = state.talkMessage[0],
                                    _scorll = 'bottom_'+ okaTool.getUUID();

                                if( $firstTalk && $firstTalk.cid === $talk.cid ) {

                                    if( _direction === 'up' ) {
                                        let $result = $messages.concat(state.talkMessage);

                                        this.commit('changeState', {
                                            talkMessage: $result,
                                        });
                                        
                                        // _scorll = 'find_'+ $firstTalk.uuid;

                                        _scorll = 'prev_'+ okaTool.getUUID();
                                    }else if( _direction === 'down' ){

                                        $messages.forEach(item => {
                                            let $target = state.talkMessage.find(message => message.mid === item.mid );

                                            if( $target ){ //刪除訊息
                                                $target.type = item.type;
                                                $target.message = item.message;
    
                                                _scorll = '';
                                            }else{ //發送訊息
                                                state.talkMessage.push(item);
                                            }
                                        });
                                    }
                                }else {

                                    this.commit('changeState', {
                                        talkMessage: $messages,
                                    });
                                }
                                
                                if( _scorll ) {
                                    
                                    this.commit('talkSet', {
                                        scroll: _scorll 
                                    });
                                }
                            }
                            
                            break
                    
                        case 'getViewtimeResponse':

                            if( $talk.cid ){
                                let _cid = $talk.cid,
                                    $view = $data.viewtime2Table[_cid],
                                    $viewTime = state.talkViewTime;
    
                                let $newViewTime = okaTool.copy($viewTime);
    
                                if( !$newViewTime[_cid] ) {
                                    $newViewTime[_cid] = $view;
                                }else {
    
                                    for(let _aid in $view) {
                                        $newViewTime[_cid][_aid] = $view[_aid]
                                    }
                                }
    
                                state.talkViewTime = $newViewTime;
                            }
                        break

                        case 'getStickerListResponse':

                            if( state.stickerUnInit ) {

                                this.commit('changeState', {
                                    stickerList: $data.stickers,
                                    stickerUnInit: false,
                                });
                            }
                            
                        break
                    }
                });

                $socket.on('disconnect', () => {
                    console.log('webSocketTalk 斷線');
                });

                $socket.on('error', () => {
                    console.log('webSocketTalk 錯誤');
                });

                this.commit('changeState', {
                    webSocketTalk: $socket
                });
            },
            userNotificationInit: function(state, socket){ //init user servise

                socket.on('notification_init', (data) => {
                    let $data = data || []

                    data.forEach(item => {
                        
                        if( !item.img ) {
                            item.img = siteConfig.emptyProductPhoto;
                        }
                    });
        
                    this.commit('changeState', {
                        userNotification: $data,
                    });
                });

                socket.on('get_message', (data) => {
                    // let $data = data.message,
                    //     _title = $data.title,
                    //     _body = $data.body,
                    //     _url = $data.url;

                    // let $content = {
                    //         caption: _title,
                    //         html: _body,
                    //         path: _url,
                    //     }

                    // if( _url ) {
                    //     $content.actionIcon = 'link';
                    //     $content.actionName = '去看看';
                    //     $content.cancel = true;

                    //     this.commit('pushPopUp', {
                    //         type: 'routerPush',
                    //         content: $content,
                    //     });

                    // }else {

                    //     this.commit('pushPopUp', {
                    //         type: 'alert',
                    //         content: $content,
                    //     });
                    // }
                });

                socket.on('notification_update', (data) => {
                    let $userNotification = state.userNotification;
                        
                    if( !data.img ) {
                        data.img = siteConfig.emptyProductPhoto;
                    }

                    // console.log('notification_update', data);

                    $userNotification.unshift(data);
                    
                    this.commit('pushNotification', {
                        type: 'notification',
                        content: {
                            html: data.title,
                            status: 'success'
                        }
                    });
                });
            },
            userNotificationGet: function(state, opt){

                if( state.webSocketServise.emit ) {
                    state.webSocketServise.emit('get_message', opt);
                }
            },
            userNotificationAdd: function(state, opt){

                if( Array.isArray(opt) ) {

                    opt.forEach(item => {
                        state.userNotification.push(item);
                    })

                }else {
                    state.userNotification.push(opt);
                }
            },
            webSocketServiseDisconnect: function(state){

                if( state.webSocketServise.disconnect ) {
                    state.webSocketServise.disconnect();
                }
            },
            webSocketTalkDisconnect: async function(state){

                if( state.webSocketTalk.disconnect ) {
                    state.webSocketTalk.disconnect();
                }
            },
            setLang: function(state, opt){
                let $opt = opt || {},
                    _id = $opt.id || 'zh',
                    $_callback = $opt.callback;

                this.commit('changeState', {
                    langID: _id,
                });

                if( _id === 'zh' ) {
                    Validator.localize('zh_TW', validatorZh_TW);
                }else {
                    Validator.localize('en', validatorEn);
                }

                localStorage.setItem('viewLang', _id);

                if( $_callback && typeof $_callback === 'function' ) {
                    $_callback();
                }
            },
            updateFavorite: async function(state){
                let $productList = state.productList,
                    $addList = []

                $productList.forEach(item => {

                    if( item.is_favorite ) {
                        $addList.push(item.product_sn);
                    }
                });

                if( $addList.length ) {

                    let $_core = () => {
                            let _url = siteTool.apiUrl({
                                    class: 'FavoriteList',
                                    func: 'Add',
                                }),
                                $condition = $addList;
                
                            return axios.post(_url, $condition);
                        }

                    try {
                        await $_core();

                        this.commit('initUserData');

                    }catch(error) {
                            
                        this.commit('catchError', {
                            error: error,
                            callback: () => {
                                this.commit('updateFavorite');
                            }
                        });
                    }
                }else {
                    this.commit('initUserData');
                }
            },
            initTalkData: async function(state) {
                let $user = state.user,
                    _accountid = $user.accountid,
                    _adscuno = $user.adscuno;

                _accountid = _accountid.toUpperCase();

                let _account = 'FPCEC-'+ _accountid,
                    _password = _adscuno || _accountid;

                // 測試機的測試帳號
                // let _account = 'EC-JHMS001B', //EC-JHMS001B
                //     _password = 1234;

                let _url = siteConfig.talkLoginUrl,
                    $form = new URLSearchParams({
                        account: _account,
                        password: _password,
                    });
                    
                try {
                    let $response = await axios.post(_url, $form);

                    if( $response.error ) {
                        this.commit('talkSet', talkTool.getDefaultTalk())
                    }else {
                        this.commit('talkSet', $response.data);
                        this.commit('webSocketTalkInit');
                    }

                }catch(error) {
                    this.commit('clearTalk');
                    console.log(error)
                }
            },
            initUnDiscountCuno: async function(state){
                    
                this.commit('changeState', {
                    unDiscountCuno: [],
                });

                let $_getData = () => {
                        let _url = siteTool.apiUrl({
                                class: 'BindCuno',
                                func: 'List',
                            })
                        
                        return axios.post(_url, {});
                    }

                try {
                    let $data = await $_getData();
                
                    this.commit('changeState', {
                        unDiscountCuno: $data || [],
                    });

                }catch(error) {
                        
                    this.commit('catchError', {
                        error: error,
                        callback: () => {
                            this.commit('initUnDiscountCuno');
                        }
                    });
                }
            },
            initProductClassData: async function(state, callback){
                    
                this.commit('changeState', {
                    productClass: [],
                });

                let $_getData = () => {
                        let _url = siteTool.apiUrl({
                                class: 'Product',
                                func: 'BasicClass',
                            }),
                            $condition = []
                        
                        return axios.post(_url, $condition);
                    }

                try {
                    let $data = await $_getData();
                
                    this.commit('changeState', {
                        productClass: $data,
                    });

                    if( callback && typeof callback === 'function' ) {
                        callback();
                    }

                }catch(error) {
                        
                    this.commit('catchError', {
                        error: error,
                        callback: () => {
                            this.commit('initProductClassData', callback);
                        }
                    });
                }
            },
            setPriceObject: async function(state, opt){
                let $priceObject = state.priceObject,
                    _sn = opt.sn,
                    _date = opt.date,
                    _price = opt.price;

                if( !$priceObject[_sn] ) {
                    $priceObject[_sn] = {}
                }

                $priceObject[_sn][_date] = _price;
            },
            updatePriceObject: function(state){ //更新價格資訊
                let _date = new Date().toLocaleDateString();

                state.productList.forEach(item => {

                    this.commit('setPriceObject', {
                        sn: item.product_sn,
                        date: _date,
                        price: item.price,
                    });
                });

                this.commit('changeState', {
                    productListInit: _date,
                });
            },
            initProductData: async function(state, callback){

                let $_getData = () => {
                        let _url = siteTool.apiUrl({
                                class: 'Product',
                                func: 'List',
                            }),
                            $condition = {}
            
                        return axios.post(_url, $condition);
                    }

                try {
                    let $data = await $_getData();

                    $data.forEach(item => {

                        if( !item.imageurl ) {
                            item.imageurl = siteConfig.emptyProductPhoto;
                        }

                        item.files = []
                    });
                
                    this.commit('changeState', {
                        productList: $data,
                    });

                    this.commit('updatePriceObject');

                    if( callback && typeof callback === 'function' ) {
                        callback();
                    }

                }catch(error) {
                        
                    this.commit('catchError', {
                        error: error,
                        callback: () => {
                            this.commit('iniProductData', callback);
                        }
                    });
                }
            },
            updateProductFile: function(state, opt){
                opt.target.files = opt.target.files.concat(opt.files);
            },
            initCredit: async function(state, callback){
                let $user = state.user,
                    _sn = $user.sn,
                    _codiv = $user.co +''+ $user.div;

                let $_error = () => {
                        
                        this.commit('changeState', {
                            creditBalance: null,
                            creditTime: null,
                        });
                    }

                if( state.token && _sn ) {

                    let $_getData = () => {
                            let _url = siteTool.apiUrl({
                                    class: 'Credit',
                                })
                
                            return axios.post(_url, []);
                        }
    
                    try {
                        let $data = await $_getData();

                        if( $data && (_codiv === '11' || _codiv === '18') ) {
                        
                            this.commit('changeState', {
                                creditBalance: $data.credit,
                                creditTime: $data.synctime,
                            });
                        }
        
                        if( callback && typeof callback === 'function' ) {
                            callback();
                        }
                    }catch(error) {
                        $_error();
                            
                        this.commit('catchError', {
                            error: error,
                            callback: () => {
                                this.commit('initCredit', callback);
                            }
                        });
                    }
                }else {
                    $_error();
    
                    if( callback && typeof callback === 'function' ) {
                        callback();
                    }
                }
            },
            initPackageAndQuality: async function(state, date, callback){

                if( state.token && state.user.sn ) {

                    let $_getPackageData = () => {
                            let _url = siteTool.apiUrl({
                                    class: 'Package',
                                    func: 'List',
                                }),
                                $condition = {
                                    date: date
                                }
                
                            return axios.post(_url, $condition);
                        },
                        $_packageMultipleData = () => {
                            let _url = siteTool.apiUrl({
                                    class: 'PackageMultiple',
                                })
                
                            return axios.post(_url, {
                                codiv: state.user.co + state.user.div
                            });
                        },
                        $_getQualityList = () => {
                            let _url = siteTool.apiUrl({
                                    class: 'Quality',
                                    func: 'List',
                                }),
                                $condition = {
                                    date: date
                                }
                
                            return axios.post(_url, $condition);
                        },
                        $_getDispatchList = () => {
                            let _url = siteTool.apiUrl({
                                    class: 'Product',
                                    func: 'Companylist',
                                }),
                                $condition = {}
                
                            return axios.post(_url, $condition);
                        }
    
                    try {
                        let $response = await Promise.all([
                                $_getPackageData(),
                                $_packageMultipleData(),
                                $_getQualityList(),
                                $_getDispatchList(),
                            ]);
    
                        let [packageData, packageMultipleData, qualityList, dispatchList] = $response;

                        if( state.langID !== 'zh' ) {

                            let $_changeRemarks = (array) => {
                                
                                    array.forEach(item => {
    
                                        if( item.remarks_e ) {
                                            item.remarks = item.remarks_e;
                                        }
                                    });
                                }

                            $_changeRemarks(packageData);
                            $_changeRemarks(qualityList);
                        }

                        //2023/10/02_增加包裝是否有上下架的條件篩選
                        let $qualityList = qualityList.filter(item => item.availability),
                            $packageData = packageData.filter(item => item.availability),
                            $dispatchList = dispatchList || []

                        if( $dispatchList.data ) {
                            $dispatchList = $dispatchList.data;
                        }
                        
                        this.commit('changeState', {
                            packageData: $packageData,
                            packageMultipleData: packageMultipleData,
                            qualityList: $qualityList,
                            dispatchList: $dispatchList,
                        });
    
                        if( callback && typeof callback === 'function' ) {
                            callback();
                        }
                    }catch(error) {
                            
                        this.commit('catchError', {
                            error: error,
                            callback: () => {
                                this.commit('initPackageAndQuality', callback);
                            }
                        });
                    }
                }else {
    
                    if( callback && typeof callback === 'function' ) {
                        callback();
                    }
                }
            },
            AddListToShoppingCart:async function(state, opt){
                let $priceObject = state.priceObject,
                    $shoppingCart = []

                let $data = opt.data || [],
                    $_callback = opt.callback;

                let $_getContactRemark = (dsr) =>{
                    //取得聯絡備註
                    let _url = siteTool.apiUrl({
                        class: 'ContactRemark',
                    }),
                    $condition = {
                        product_s: dsr
                    }

                    return axios.post(_url, $condition);
                }

                await Promise.all($data.map(async item => {
                    let $target = siteTool.getProduct(item);

                    if( $target ) {
                        let _sn = $target.product_sn,
                            _date = new Date(item.customer_need_date * 1000).toLocaleDateString();

                        if( $priceObject[_sn] === undefined || $priceObject[_sn][_date] === undefined ) {

                            let $info = await siteTool.getProductInfo({
                                    sn: _sn,
                                    date: _date,
                                }),
                                $detail = $info.detail || {},
                                _price = $detail.price || null;

                            this.commit('setPriceObject', {
                                sn: _sn,
                                date: _date,
                                price: _price,
                            });
                        }

                        let $contact = await $_getContactRemark(item.product_s)
                            item.contactRemark = $contact.contact_remark;
    
                        $shoppingCart.push(siteTool.initShoppingCart(item));

                        return true;

                    }else {
                        console.log('找不到此產品');

                        return false;
                    }
                }));

                $shoppingCart.sort((a, b) => a.cart_sn > b.cart_sn? 1: -1);
         
                this.commit('changeState', {
                    shoppingCart: $shoppingCart,
                    shoppingCartInit: true,
                });

                if( $_callback && typeof $_callback === 'function' ) {
                    $_callback();
                }
            },
            buyAgain: function(state, inqtno){
                let $langLibrary = state.langLibrary,
                    $lang = $langLibrary[state.langID]

                let $shoppingCart = state.shoppingCart,
                    _length = $shoppingCart.length;

                let $_core = async () => {
                        let _url = siteTool.apiUrl({
                                class: 'ShoppingCart',
                                func: 'AddAgain',
                            }),
                            $condition = {
                                inqtno,
                            }
                    
                        try {
                            let $data = await axios.post(_url, $condition);

                            this.commit('AddListToShoppingCart', {
                                data: $data,
                                callback: () => {
                                    router.push('/system/cartList');
                                }
                            });

                            let items = [];

                            $data.forEach(data => {
                                let obj = {};
                                obj['item_name'] = data.product_s;
                                items.push(obj);
                            })

                            window.dataLayer = window.dataLayer || [];
                            dataLayer.push({
                                event: "buy_again",
                                product: items,
                                userId: state.user.accountid, //帳號
                                userName: state.user.cuabr, //簡稱
                                customer: state.user.cuno,
                            });
                            
                        }catch(error) {

                            this.commit('catchError', {
                                error: error,
                                callback: $_core,
                            });
                        }
                    }
                    
                if( _length ) {

                    this.commit('pushPopUp', {
                        type: 'confirm',
                        content: {
                            caption: $lang['product.myorders.func.buyagain'],
                            html: $lang['func.buyagain.alert'],
                            action: $_core
                        }
                    });
                }else {
                    $_core();
                }
            },
            initShoppingCartData: async function(state, callback){

                if( state.token && state.user.sn ) {

                    let $_getData = () => {
                            let _url = siteTool.apiUrl({
                                    class: 'ShoppingCart',
                                    func: 'List',
                                });
                
                            return axios.post(_url, []);
                        }

                    try {
                        let $data = await $_getData();

                        this.commit('AddListToShoppingCart', {
                            data: $data,
                        });

                    }catch(error) {
                            
                        this.commit('catchError', {
                            error: error,
                            callback: () => {
                                this.commit('initShoppingCartData', callback);
                            }
                        });
                    }
                }else {
    
                    if( callback && typeof callback === 'function' ) {
                        callback();
                    }
                }
            },
            initHolidayList: async function(state, callback){
                //20221004 擴充可選日期(當月&下個月) https://www.notion.so/6c112dae092d4cd08ee2ce08f5354364

                let $_getData = () => {
                        let _url = siteTool.apiUrl({
                            class: 'Holiday',
                            func: 'List',
                        })

                        return axios.post(_url, []);
                    }

                try {
                    let $list = await $_getData();

                    let $_getYmd = (number) => {
                            let _date = new Date(number).toLocaleDateString(), // 2022/2/2
                                $date = _date.split('/');

                            $date[1] = okaTool.doubleCount($date[1]);
                            $date[2] = okaTool.doubleCount($date[2]);

                            return $date.join('-');
                        }

                    $list = $list.map(item => {
                        return new Date(item).getTime();
                    });

                    let $toDay = okaTool.timeInterval({ //今日
                            time: new Date(),
                            unit: 'date'
                        }),
                        _nextMonth = okaTool.timeInterval({
                            time: new Date(),
                            away: 'after',
                            unit: 'month',
                            int: 1
                        }),
                        _toDate =  $toDay.ymd.split('-'), //今日
                        _nextDate =  _nextMonth.ym.split('-'),//下個月
                        _days = new Date(_toDate[0],_toDate[1], 0).getDate()- new Date().getDate() +  new Date(_nextDate[0],_nextDate[1], 0).getDate(), //當前月份剩餘天數+下個月的天數
                        _aDay = 86400000,//每天總毫秒
                        _toDaye = new Date($toDay.ymd).getTime(), //今日的毫秒
                        $result = [];
                    
                    let _date = null;
                    if(store.getters.division == 'HP'){
                        // https://www.notion.so/0f08d1488dec441ea5a3655d164e0f1e
                        // 20221230_HP化品六日不擋，仍舊可以下單

                        for( let _i = 0; _i <= _days; _i++ ) { //列出下單日當天後所有可以選的日期
                            _date = _toDaye + _aDay * _i;
    
                            $result.push($_getYmd(_date));
                        }
                    }else{
                        for( let _i = 0; _i <= _days; _i++ ) { //列出下單日當天後所有可以選的日期
                            _date = _toDaye + _aDay * _i;
    
                            if( !$list.find(item => item === _date) ) { //去掉在假日列表內的日期
                                $result.push($_getYmd(_date));
                            }
                        }
                    }
                    
                    let $div = ['AH','DS','TRL','HP']
                    if( $div.includes(store.getters.division)){
                        //https://www.notion.so/c4d2ac11d32e48709d03957a78a1e5d5
                        //20221021_TRL要求將日期限制改為隔1工作天可下單
                        // https://www.notion.so/0f08d1488dec441ea5a3655d164e0f1e
                        // 20221230_AH台塑旭、DS電石、TRL台曆朗、HP化品要求今天以後都可以下單
                        // $result.splice(0, 1);
                    }else{
                        $result.splice(0, 2);//將包含下單日當天的2個工作天刪掉
                    }

                    let _initDate = new Date().toLocaleDateString();

                    this.commit('changeState', {
                        selectedDateList: $result,
                        selectedDateListInit: _initDate,
                    });

                    if( callback && typeof callback === 'function' ) {
                        callback();
                    }

                }catch(error) {
                        
                    this.commit('catchError', {
                        error: error,
                        callback: () => {
                            this.commit('initHolidayList', callback);
                        }
                    });
                }
            },
            initUserData: async function(state){
                this.commit('initProductData', () => {
                    this.commit('initShoppingCartData');
                });
                this.commit('initPackageAndQuality');
                // this.commit('initCredit');
            },
            getLang: async function(state, callback){
                let _i18n = process.env.BASE_URL+'i18n.json'

                try {
                    let _response = await axios.get(_i18n);

                    let _data = _response.data,
                        _result = {}
                    
                    let _lang = _data.find(item => item.parameter === 'site.noun.language');

                    for (let [key, value] of Object.entries(_lang)) {

                        if( key !== 'parameter' ) {
                            _result[key] = {}

                            _data.forEach(data => {
                                let _parameter = data.parameter.toLowerCase()

                                _result[key][_parameter] = data[value]
                            });
                        }
                    }

                    this.commit('changeState', {
                        langLibrary: _result
                    });

                    if( callback && typeof callback === 'function' ) {
                        callback();
                    }

                }catch(error) {
                        
                    this.commit('catchError', {
                        error: error,
                        callback: () => {
                            this.commit('getLang', func);
                        }
                    });
                }
            },
        },
        actions: {
            getUser: async function(context, token){ //登入取得 server 認證並導入其他頁或執行方法
                let $state = context.state,
                    $mutations = context.commit;
    
                $mutations('changeState', {
                    token: token,
                });

                let _url = siteConfig.ApiUrl +'/users/info';
                
                try {
                    let $data = await axios.post(_url);

                    if($data.salid === 'N'){
                        
                        let _exportUrl = siteConfig.devEvent ? 'https://ec.fpcetg.com.tw/ecfrontapitest/account/login/cloud': 'https://ec.fpcetg.com.tw/ecfrontapi/account/login/cloud',
                            $condition = {
                                co: $data.co,
                                div: $data.div,
                                salid: $data.salid,
                                cuno: $data.cuno,
                                sha256: token.split('bearer ')[1] //前面拿到的token 不包含b開頭那串
                            }

                        let $response = await axios.post(_exportUrl, $condition);

                        window.location.href = $response;
                        
                    }else{
                        let _id = $data.accountid,
                            $accounts = $state.accounts,
                            $clone = okaTool.copy($accounts),
                            $target = $clone.find(account => account.id === _id);

                        if( $target ) {
                            $target.token = token;
                        }else {
                            let _name = $data.cuabr || $data.cufn || $data.cuno,
                                _photo = siteConfig.ApiUrl +'/AccountPhoto/'+ _id +'.jpg';

                            $clone.push({
                                id: $data.accountid,
                                name: _name,
                                photo: _photo,
                                token: token,
                                co: $data.co,
                                div: $data.div,
                            });
                        }

                        if( $state.user.sn ) { //如果有 user 就代表帳號轉帳號，要先把我的最愛移掉

                            $state.productList.forEach(item => {
                                item.is_favorite = false;
                            });
                        }            

                        //這裡要重新清除所有東西
                        $mutations('clearAuth');
                        $mutations('clearUserData');
                        
                        $mutations('changeState', {
                            token: token,
                            accounts: $clone,
                        });
        
                        VueCookie.set('token', token, 3);
                        VueCookie.set('accounts', JSON.stringify($clone), 3);

                        $mutations('loginProcess', $data);

                        //不同事業部可選的日期不一樣，所以要重抓
                        this.commit('initHolidayList');
                        this.commit('initUnDiscountCuno');
                    }

                }catch(error) {

                    $mutations('catchError', {
                        error: error,
                    });
                }
            },
            getAuth: async function(context, res){ //登入取得 server 認證並導入其他頁或執行方法
                let _account = res.account || '',
                    _password = res.password || '';
                
                let $state = context.state,
                    $mutations = context.commit,
                    $dispatch = context.dispatch;

                if( res.callback && typeof res.callback === 'function' ) {
                    $mutations('confirmFuncQueuePush', res.callback);
                }

                let _url = siteConfig.ApiUrl +'/users/login';

                let $condition = {
                        account: _account,
                        pwd: _password
                    }
                    
                try {
                    let $response = await axios.post(_url, $condition),
                        _token = $response.token;

                    $dispatch('getUser', _token);

                }catch(error) {

                    $mutations('catchError', {
                        error: error,
                    });
                }
            }
        }
    });

export default store;
